import {Injectable,TemplateRef} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  spinners: any[]=[];

  constructor() {}

  show(options: any={}) {
    this.spinners.push({...options});
  }

  remove(spinner: any) {
    this.spinners=this.spinners.filter(t => t!==spinner);
  }

  close() {
    this.spinners = [];
  }

  class(spinner: any) {
    let claseSpinner='spinner-border text-light';
    switch(spinner.type) {
      case 'primary':
        claseSpinner='spinner-border text-primary';
        break;

      case 'secondary':
        claseSpinner='spinner-border text-secondary';
        break;

      case 'success':
        claseSpinner='spinner-border text-success';
        break;

      case 'danger':
        claseSpinner='spinner-border text-danger';
        break;

      case 'warning':
        claseSpinner='spinner-border text-warning';
        break;

      case 'info':
        claseSpinner='spinner-border text-info';
        break;
      
      case 'light':
        claseSpinner='spinner-border text-light';
        break;

      case 'dark':
        claseSpinner='spinner-border text-dark';
        break;

      case 'grow':
        claseSpinner='spinner-grow';
        break;
    }
    return claseSpinner;
  }

}
